// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"4e638e40","146":"e8b3bcbd","203":"64b39a0c","292":"8a29f94a","911":"bb83f052"}[chunkId] + ".chunk.css";
};